// extracted by mini-css-extract-plugin
export default {"bottomAreaGrid":"bottomArea_bottomAreaGrid__M+a2Z","bottomAreaGridChild":"bottomArea_bottomAreaGridChild__KMQZ5","orangeText":"bottomArea_orangeText__4ieeQ"};